import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../../utils';
import { CustomButtonn } from '../../../../../../components';
import { useLocation } from 'react-router-dom';


const initialCIFDataObj = {
    data: [],
    loading: false
};

const TABLE_COLUMNS = [
    {
        header: 'Therapeutic Name',
        accessor: (row) => {
            const status = row.status;
            return (
                <span
                    style={{
                        color: status === 'inactive' ? 'red' : 'black',
                    }}
                >
                    {`${row.therapeutic_name}`}
                </span>
            );
        },
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: "uppercase" }
    },
    {
        header: 'Created At',
        accessor: 'createdAt'
    }
];

export const TherapeuticCIF = ({ getTherapeuticDropdown, setAddCifDialogue }) => {
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [therapeuticDataObj, setTherapeuticDataObj] = useState(initialCIFDataObj);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();

    const methods = useForm({
        resolver: yupResolver(Yup.object().shape({ therapeutic_name: Yup.string().required('Therapeutic Name is required') })),
        mode: 'all'
    });
    const { handleSubmit, setValue, reset } = methods;

    useEffect(() => {
        if (selectedRecord) {
            setValue('therapeutic_name', selectedRecord.therapeutic_name);
        } else {
            reset();
        }
    }, [setValue, reset, selectedRecord]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/pharmacy-therapeutic-update' : '/pharmacy-therapeutic-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: {
                therapeutic_name: formValues.therapeutic_name,
            }
        });
        if (response?.success) {
            toast(`Successfully ${editFlag ? 'updated' : 'created'} Company Name `, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            reset();
            handleFetchList()
            getTherapeuticDropdown()
        } else {
            toast(`Failed to ${editFlag ? 'update' : 'create'} Company Name `, {
                variant: 'error'
            });
        }
        setLoading(false);
    };

    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/pharmacy-therapeutic-cancel', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully cancelled Company', { variant: 'success' });
            setSelectedRecord();
            handleFetchList()
        } else {
            toast('Failed to cancelled Company', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/pharmacy-therapeutic-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Company', { variant: 'success' });
            setSelectedRecord();
            handleFetchList();
        } else {
            toast('Failed to delete Company', { variant: 'error' });
        }
        setLoading(false);
    };


    const handleFetchList = async () => {
        setOpenQueryDialog(true);
        setTherapeuticDataObj({ loading: true });
        const response = await request('/pharmacy-therapeutic-list', { method: 'GET' });
        if (response.success) {
            const filteredData = response.data.filter(item =>
                item.status === 'active' || item.status === 'inactive' || item.status === 'default'
            );
            setTherapeuticDataObj({ loading: false, data: filteredData });
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setTherapeuticDataObj({ loading: false });
        }
    };
    useEffect(() => {
        handleFetchList()
    }, [])
    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto',
                maxWidth: '100vw',
                minHeight: '100vh'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        p: 0.2,
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                pb: 0.5,
                                mb: 1,
                                borderBottom: '1px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Manage Therapeutic CIF
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        reset();
                                    }}
                                    id={`${lastPathSegment}Write`}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                        handleCancelRecord()
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                        setAddCifDialogue(false)
                                    }}
                                >Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Stack spacing={2} sx={{ marginBottom: "1%" }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Typography sx={{ flex: 0.4, fontSize: '1.6rem', fontWeight: 700 }}>Therapeutic Name*</Typography>
                                <TextField
                                    name="therapeutic_name"
                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                    inputProps={{ sx: { fontSize: '1.4rem' } }}
                                    placeholder="Therapeutic  Name"
                                    fullWidth
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                />

                            </Stack>
                        </Stack>
                        <Stack
                            padding={0}
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                            borderBottom="1px solid"
                            borderColor="grey.300"
                        >
                        </Stack>
                        <Table
                            sx={{ mt: 0.5 }}
                            columns={TABLE_COLUMNS}
                            data={therapeuticDataObj.data || []}
                            loading={therapeuticDataObj.loading}
                            onRowClick={(row) => {
                                setSelectedRecord(row);
                                setOpenQueryDialog(false);
                            }}
                        />
                    </FormProvider>
                </Container>
            </Paper >
        </>
    );
};
